<template>
  <div :style="fullWindow4to3RatioDimensionStyle" class="relative">
    <TimelapseVideoPlayer
      autoPlay
      keepControls
      :loading="loading"
      :timestamps="timelapse.timestamps"
      :src="timelapse.presigned_url_timelapse"
      :noSrcMessage="$t('err.no_data_yet')"
      :formatTime="formatMilestoneTime"
    />
    <div class="absolute top-3 right-3 flex items-center gap-4">
      <a :href="timelapse.presigned_url_timelapse" v-if="!loading">
        <ArrowDownTrayIcon class="h-6 w-6 text-white hover:text-yellow-300" />
      </a>
      <LogoWatermark />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ArrowDownTrayIcon } from "@heroicons/vue/24/solid";
import { format, isValid } from "date-fns";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import TimelapseVideoPlayer from "shared/components/camera/TimelapseVideoPlayer.vue";
import LogoWatermark from "shared/components/other/LogoWatermark.vue";
import { useCurrentCustomerName, useCurrentSiteId } from "shared/composables/project";
import { useFullWindow4to3RatioDimensionStyle } from "shared/composables/screen";
import CameraRepository from "shared/repositories/CameraRepository";
import PublicTokenRepository from "shared/repositories/PublicTokenRepository";
import logger from "shared/services/logger";
import { ProjectTimelapseResponse } from "shared/types/Camera";

const { t } = useI18n();

const loading = ref(false);
const timelapse = ref<ProjectTimelapseResponse>({
  presigned_url_timelapse: "",
  timestamps: [],
});
const noSrcMessage = ref<string | undefined>(undefined);

const currentCustomerName = useCurrentCustomerName();
const currentSiteId = useCurrentSiteId();
const route = useRoute();

const fullWindow4to3RatioDimensionStyle = useFullWindow4to3RatioDimensionStyle();

const formatMilestoneTime = (time: Date) => {
  return isValid(time) ? format(time, "dd.MM.yyyy HH:mm") : "";
};

onMounted(() => {
  loading.value = true;
  noSrcMessage.value = undefined;

  CameraRepository.loadProjectTimelapse(
    currentCustomerName,
    currentSiteId,
    route.params.camera_id as string,
  )
    .then((data) => {
      timelapse.value = data;
    })
    .catch((error) => {
      if (PublicTokenRepository.isPublicTokenAuthError(error)) {
        noSrcMessage.value = t("public_tokens.link_expired");
      } else {
        logger.error(error);
      }
    })
    .finally(() => {
      loading.value = false;
    });
});
</script>
